import { useQuery } from '@tanstack/react-query';

import type { CommunityCityChannelsResponse } from '~/interfaces/community/space';

const fetchCityChannelStats = async (): Promise<CommunityCityChannelsResponse> => {
  const response = await fetch('/community/city_channels');
  if (!response.ok) throw new Error('Failed to fetch city channels');

  return response.json();
};

export const useCityChannelStats = () =>
  useQuery({ queryKey: ['community-city-channel-stats'], queryFn: fetchCityChannelStats });
